module.exports = __webpack_public_path__ + "static/media/tg3.2a56c280.jpg";